import { camelizeKeys } from "humps";
import { HQ_SERVICE } from "app_constants";
import {
  checkStatus,
  deleteRequest,
  getRequest,
  parseJSON,
  postRequest,
} from "helpers/requests";

const URI = `${HQ_SERVICE}/super_users/merchant_group_sessions`;

export interface IAccountLocation {
  name: string;
  salesforceAccountId: string;
}

export interface IMerchantGroup {
  name: string;
  salesforceId: string;
  accounts: IAccountLocation[];
}

function getSearchMerchantGroups(query: string): Promise<IMerchantGroup[]> {
  return fetch(`${URI}?query=${encodeURIComponent(query)}`, getRequest())
    .then(checkStatus)
    .then(parseJSON)
    .then(camelizeKeys) as Promise<IMerchantGroup[]>;
}

function postStartMerchantGroupSession(
  salesforceId: string
): Promise<Response> {
  return fetch(URI, postRequest({ salesforceId })).then(checkStatus);
}

function deleteStopMerchantGroupSession(): Promise<Response> {
  return fetch(URI, deleteRequest()).then(checkStatus);
}

export {
  getSearchMerchantGroups,
  postStartMerchantGroupSession,
  deleteStopMerchantGroupSession,
};
